<template>
	<div>
		<div class="card">
			<div class="card-body">

				<div class="row align-items-center">
					<div class="col-auto">
						<a href="#!" class="avatar avatar-lg">
						<img :src="article.image" alt="..." class="avatar-img rounded">
						</a>
					</div>

					<div class="col ml--2">

						<h4 class="card-title mb-1 name"><a href="#!">{{ article.title }}</a></h4>

						<p class="card-text small text-muted mb-1">	{{ article.content }} </p>

						<p class="card-text small text-muted">
						Added by Dianna Smiley on <time datetime="2018-01-03">{{ article.date_created }}</time>
						</p>
						
					</div>
					<!-- <div class="col-auto">
						
						<a href="#!" class="btn btn-sm btn-white d-none d-md-inline-block">
						Download
						</a>

					</div> -->
					<div class="col-auto">
						
						<div class="dropdown">
							<a href="#!" class="dropdown-ellipses dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<i class="fe fe-more-vertical"></i>
							</a>
							<div class="dropdown-menu dropdown-menu-right">
								<a href="#!" class="dropdown-item">Action</a>
								<a href="#!" class="dropdown-item">Another action</a>
								<a href="#!" class="dropdown-item">Something else here</a>
							</div>
						</div>

					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ArticleListComponent',
		props: ['article']
	}
</script>


// WEBPACK FOOTER //
// src/components/backend/ArticleListComponent.vue